export default __webpack_public_path__ + "static/media/diamond-about.23faf36b.svg";